import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DarkModeStore {
  #darkModeResource: ResourceRef<boolean | undefined> = resource({
    loader: (): Promise<boolean> => {
      const storage: string | null = localStorage.getItem('darkMode');
      if (storage !== null) {
        return Promise.resolve(this.stringToBoolean(storage));
      }
      const prefersDark = window.matchMedia?.(
        '(prefers-color-scheme: dark)'
      ).matches;
      return Promise.resolve(prefersDark);
    },
  });

  constructor() {
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', event => {
        const storage = localStorage.getItem('darkMode');
        if (storage === null) {
          this.#darkModeResource.update(() => event.matches);
        }
      });
  }

  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#darkModeResource.isLoading()
  );
  readonly isActive: Signal<boolean> = computed((): boolean =>
    this.#darkModeResource.hasValue()
      ? (this.#darkModeResource.value() ?? false)
      : false
  );

  loadDarkMode(): void {
    this.#darkModeResource.reload();
  }

  updateDarkMode(query: boolean): void {
    this.#darkModeResource.update((): boolean => query);
  }

  save(value: boolean): void {
    localStorage.setItem('darkMode', String(value));
  }

  private stringToBoolean(str: string): boolean {
    return str.toLowerCase() === 'true';
  }
}
